/**
 * `/cases` — the subscriber's own queue.
 *
 * One `RouteObject`, so the file is `queue.route.tsx` (singular). The route
 * resolves nothing and fetches nothing: no `loader` in this repo performs a
 * data read, because a fetching loader would create a cache TanStack Query
 * does not know about and the two would drift on every mutation.
 */
import type { RouteObject } from 'react-router-dom';

export const caseQueueRoute: RouteObject = {
  path: 'cases',
  lazy: async () => {
    const { CaseQueuePage } = await import('./CaseQueuePage');
    return { Component: CaseQueuePage };
  },
};
